import { GetterTree } from 'vuex'
import { TrailState } from './types'
import { RootState } from '../types'
import { TrailsHelpers } from '@/helpers/mainExports'
export const getters: GetterTree<TrailState, RootState> = {
  getThing(state) {
    return state.thing
  },
  hasThingServiceTelemery(state) {
    const hasTelemetryService = Boolean(
      state.thing?.services['mrn:service:telemetry']
    )
    return hasTelemetryService
  },
  getThingPage(state) {
    return state.thingPage
  },
  getThingTrailLocations(state) {
    return state.trailLocations
  },
  getTrailsLocationByPage(state) {
    return state.trailLocationByPage
  },
  getLocations(state) {
    return state.locations
  },
  getLastPointTrailLocations(state) {
    return state.lastPointTrailLocations
  },
  getLocationsWithEvents(state) {
    return state.locationsWithEvents
  },
  getGeofenceLocation(state) {
    return state.geoReference
  },
  getThingTrailSummary(state, getters) {
    if (JSON.stringify(state.thingTrailSummary) === '[]') return {}

    const {
      distance,
      max_speed: maxSpeed,
      time_in_movement: timeInMovement,
      time_stopped: timeStopped,
      time_with_contact_off: timeWithContactOff,
      fuel_consumption: fuelConsumption,
      max_temperature: maxTemperature
    } = state.thingTrailSummary

    const distanceFormatted = TrailsHelpers.convertMetersToKm(distance)
    const timeInMovementFormatted = TrailsHelpers.convertSectoDay(
      timeInMovement
    )
    const timeStoppedFormatted = TrailsHelpers.convertSectoDay(timeStopped)
    const timeWithContactOffFormatted = TrailsHelpers.convertSectoDay(
      timeWithContactOff
    )
    const timeWithContactFormatted = TrailsHelpers.convertSectoDay(
      timeInMovement + timeStopped
    )

    if (state.thing.type === 'vehicle') {
      const fuelConsumptionFormatted = fuelConsumption.toFixed(1)
      const maxTemperatureFormatted = maxTemperature.toFixed(1)
      return {
        distanceFormatted,
        fuelConsumptionFormatted,
        timeInMovementFormatted,
        timeWithContactOffFormatted,
        timeWithContactFormatted,
        timeStoppedFormatted,
        maxSpeed,
        maxTemperatureFormatted
      }
    } else {
      return {
        distanceFormatted,
        maxSpeed,
        timeInMovementFormatted,
        timeStoppedFormatted,
        timeWithContactOffFormatted
      }
    }
  },
  dataLoading(state) {
    return state.dataLoading
  },
  dataGeoreferenceLoading(state) {
    return state.dataGeoreferenceLoading
  },
  getMarkerToHighlight(state) {
    return state.markerHighlighted
  },
  getQueryTimestamp(state) {
    return state.queryTimestamp
  },
  getFirstFuelTankNonNull(state) {
    let firstFuelTankNonNull
    for (let i = 0; i < state.trailLocations.length; i++) {
      if (state.trailLocations[i].fuelTank != -1) {
        firstFuelTankNonNull = state.trailLocations[i].fuelTank
        break
      }
    }
    return firstFuelTankNonNull
  },
  getLastFuelTankNonNull(state) {
    let lastFuelTankNonNull
    for (let i = state.trailLocations.length - 1; i > -1; i--) {
      if (state.trailLocations[i].fuelTank != -1) {
        lastFuelTankNonNull = state.trailLocations[i].fuelTank
        break
      }
    }
    return lastFuelTankNonNull
  }
}
